<div class="contacto mt-5 pt-5 pb-5 ">

  <div class="titulo">
    <app-titulo-descripcion titulo={{titulo}} descripcion={{descripcion}}></app-titulo-descripcion>
  </div>

  <div class="formulario m-auto pt-5">
    <h2 class="subtitulo-a text-center mb-3">
      <i class="fas fa-pen icono mr-2"></i>
      <strong class="text-dark">{{subtituloA}} </strong>
    </h2>
    <app-formulario></app-formulario>
  </div>

  <div class="redes pt-5">
    <h2 class="subtitulo-b text-center mb-3">
      <i class="fas fa-share-square icono mr-2"></i>
      <strong class="text-dark">{{subtituloB}} </strong>
    </h2>
    <p class="texto text-center mb-3"> {{texto}} </p>
    <p class="texto red" *ngFor="let datos of datosContacto; let i=index">
      <i *ngIf="i == 0" class="fas fa-map-marker-alt mr-2 icono fa-2x"></i>
      <i *ngIf="i == 1" class="fas fa-envelope mr-2 icono fa-2x"></i>
      <i *ngIf="i == 2" class="fas fa-phone-alt mr-2 icono fa-2x"></i>
      <i *ngIf="i == 3" class="fab fa-facebook mr-2 icono fa-2x"></i>
      <i *ngIf="i == 4" class="fab fa-youtube mr-2 icono fa-2x"></i>
      <i *ngIf="i == 5" class="fab fa-twitter mr-2 icono fa-2x"></i>
      <i *ngIf="i == 6" class="fab fa-instagram mr-2 icono fa-2x"></i>
      {{datos.contacto}}
    </p>
  </div>

</div>
